import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Login from './components/pages/Login';
import Logout from './components/pages/Logout';
import EventCountdown from './components/pages/EventCountdown';
import SelectOfCompetition from './components/pages/SelectOfCompetition';
import Attempt from './components/pages/Attempt';
import ForgottenPassword from './components/pages/ForgottenPassword';
import Results from './components/pages/Results';
import Page404 from './components/pages/Page404';
import Register from './components/pages/Register';
import ThankYouPage from './components/pages/ThankYouPage';
import VerifyAccount from './components/pages/VerifyAccount';
import Home from './components/pages/Home';
import Tournaments from './components/pages/Tournaments';
import Contact from './components/pages/Contact';
import Tournament from './components/pages/Tournament';
import ResetPassword from './components/pages/ResetPassword';
import Trainings from './components/pages/Trainings';
import GallerySite from './components/pages/GallerySite';
import UserPanel from './components/pages/UserPanel';
import Series from './components/pages/Series';
import AfterTransaction from './components/pages/AfterTransaction';
import SessionExpiredPopup from './components/organisms/SessionExpiredPopup/SessionExpiredPopup';

const RouterContent = ({ sessionExpiredPopupOpen, setSessionExpiredPopupOpen }) => {
    const location = useLocation();

    const isLandingPage = location.pathname === '/' || location.pathname === '/login';

    return (
        <>
            <Routes>
                <Route path="/online-2021" element={<EventCountdown />} />
                <Route path="/register" element={<Register />} />
                <Route path="/login" element={<Login setSessionExpiredPopupOpen={setSessionExpiredPopupOpen} />} />
                <Route path="/logout" element={<Logout />} />
                {process.env.NODE_ENV === 'production' ? null : (
                    <>
                        <Route
                            path="/selectOfCompetition/:eventid"
                            element={<SelectOfCompetition />}
                        />
                        <Route path="/results/:code" element={<Results />} />
                        <Route
                            path="/results/:code/:competitionid/:roundid"
                            element={<Results />}
                        />
                        <Route
                            path="/results/:code/:competitionid/:roundid/:categoryid"
                            element={<Results />}
                        />
                    </>
                )}
                <Route path="/thank-you" element={<ThankYouPage />} />
                <Route path="/verify-account" element={<VerifyAccount />} />
                {process.env.NODE_ENV === 'production' ? null : (
                    <Route path="/attempt/:eventid/:competitionid/:roundid" element={<Attempt />} />
                )}
                <Route path="/404" element={<Page404 />} />
                <Route path="/competitions" element={<Tournaments />} />
                <Route path="/competition/:code" element={<Tournament />} />
                <Route path="/competition/:code/:panel" element={<Tournament />} />
                <Route path="/contact/faq" element={<Contact isFAQPage={true} />} />
                <Route path="/contact" element={<Contact isFAQPage={false} />} />
                <Route path="/request-password-reset" element={<ForgottenPassword />} />
                <Route path="/password-reset" element={<ResetPassword />} />
                <Route path="/trainings/:panel" element={<Trainings />} />
                <Route path="/trainings" element={<Trainings />} />
                <Route path="/gallery/:code" element={<GallerySite />} />
                <Route path="/gallery" element={<GallerySite />} />
                <Route path="/my-account/:panel/:subpanel" element={<UserPanel />} />
                <Route path="/my-account/:panel" element={<UserPanel />} />
                <Route path="/my-account" element={<UserPanel />} />
                <Route path="/series/:type/:code" element={<Series />} />
                <Route path="/series" element={<Series />} />
                <Route path="/after-transaction/:type/:id" element={<AfterTransaction />} />
                <Route path="/" element={<Home />} />
                <Route path="/*" element={<Navigate to="/" />} />
            </Routes>

            {sessionExpiredPopupOpen && !isLandingPage && (
                <SessionExpiredPopup onClose={() => setSessionExpiredPopupOpen(false)} />
            )}
        </>
    );
};

export default RouterContent;
